<template>
    <div v-if="healthSurvey">
        <b-modal
            size="md"
            v-model="modalShow"
            title="メンタルチェックの受付再開"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <div class="text-center">下記のメンタルチェックを受付再開しますか？</div>
            <div class="contentWrapper">
                <div class="contentItem">
                    <div>質問デッキ名</div>
                    <div>{{ healthSurvey.health_survey_template.name }}</div>
                </div>

                <div class="d-flex mt-3">
                    <div class="contentItem mr-3">
                        <div>開始日</div>
                        <div>{{ helper.dateForHuman(healthSurvey.survey_start_date, 'Asia/Tokyo') }}</div>
                    </div>
                    <div class="contentItem">
                        <div>終了日</div>
                        <div>{{ helper.dateForHuman(healthSurvey.survey_finish_date, 'Asia/Tokyo') }}</div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
                <div class="d-flex justify-content-center">
                    <button
                        class="btn btn-yokumiru-gray mr-2"
                        :disabled="inProgress"
                        @click="close">
                        キャンセル
                    </button>
                    <button
                        class="btn btn-success"
                        :disabled="inProgress"
                        @click="handleOk">
                        受付再開
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            group: null,
            healthSurvey: null,
        }
    },

    computed: {},

    created: function () {
        bus.$on('open-modal-admin-health-survey-resume', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-health-survey-resume')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} group
         * @param {object} healthSurvey
         */
        open: function (group, healthSurvey) {
            this.group = {...group}
            this.healthSurvey = {...healthSurvey}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 一時停止ボタン押下時
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.submit()
        },

        submit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.health_surveys.endpoint.base
            const params = {
                health_survey_template_id: this.healthSurvey.health_survey_template_id,
                group_id: this.group.id,
                survey_start_date: this.healthSurvey.survey_start_date,
                survey_finish_date: this.healthSurvey.survey_finish_date,
            }

            await axios.put(`${endpoint}/resume`, params)
                .then(() => {
                    bus.$emit('alert-success', 'メンタルチェックを受付再開しました。')
                    bus.$emit('health-survey-resumed')
                    this.close()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.contentWrapper {
    padding: 30px 15px;
}

.contentItem {
    flex-grow: 1;
    padding-bottom: 3px;
    border-bottom: 1px solid #989898;
}
</style>
